export const MainLayout = ({ debug, children }: any) => {
  return (
    <div className="flex flex-col w-screen h-screen overflow-x-hidden overflow-y-auto">
      {children}
    </div>
  );
};
